var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBinIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9391 8.69712C19.1384 8.69712 19.3193 8.78412 19.4623 8.93112C19.5955 9.08811 19.6626 9.28311 19.6432 9.48911C19.6432 9.55711 19.1102 16.297 18.8058 19.134C18.6152 20.875 17.4929 21.932 15.8094 21.961C14.5149 21.99 13.2496 22 12.0038 22C10.6811 22 9.38763 21.99 8.13206 21.961C6.50498 21.922 5.38168 20.846 5.20079 19.134C4.88763 16.287 4.36439 9.55711 4.35467 9.48911C4.34494 9.28311 4.41108 9.08811 4.54529 8.93112C4.67756 8.78412 4.86818 8.69712 5.06852 8.69712H18.9391ZM14.0647 1.99998C14.9488 1.99998 15.7385 2.61698 15.967 3.49697L16.1304 4.22696C16.2627 4.82196 16.7781 5.24295 17.3714 5.24295H20.2871C20.6761 5.24295 21 5.56595 21 5.97694V6.35694C21 6.75794 20.6761 7.09093 20.2871 7.09093H3.71385C3.32386 7.09093 3 6.75794 3 6.35694V5.97694C3 5.56595 3.32386 5.24295 3.71385 5.24295H6.62957C7.22185 5.24295 7.7373 4.82196 7.87054 4.22796L8.02323 3.54597C8.26054 2.61698 9.0415 1.99998 9.93527 1.99998H14.0647Z",
    fill: "#E25959"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/bin-icon.f70f7afaff68b1258d3b2ef032a67c4e.svg";
export { ForwardRef as ReactComponent };